<template>
  <DropdownList
    v-bind="$attrs"
    :data="filteredData"
  >
    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>
    <template #before="slotProps">
      <div class="ui-dropdown-list__search">
        <UIInputTextClearable
          v-model="searchValue"
          placeholder="Find an option..."
          :size
          :disabled
          @ready="handleReady"
        >
          <template #leading>
            <MagnifyingGlassIcon aria-hidden="true" />
          </template>
        </UIInputTextClearable>
      </div>
      <slot
        name="popper"
        v-bind="slotProps"
      />
    </template>
  </DropdownList>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { DropdownListData, InputSize } from '@types'

import DropdownList from './DropdownList.vue'
import { UIInputTextClearable } from '@ui/fields'
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline'

type Props = {
  data: DropdownListData[]
  size?: InputSize
  disabled?: boolean
}

const { data, size = 'sm' } = defineProps<Props>()

const searchValue = ref('')
  
const filteredData = computed(() => {
  return data.filter(item => item.label.toLowerCase().includes(searchValue.value.toLowerCase()))
})

const handleReady = (el: HTMLInputElement) => {
  setTimeout(() => {
    el.focus()
  }, 100)
}
</script>

<style>
.ui-dropdown-list__search {
  @apply px-1.5 py-1;
}
</style>
